import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Listar from '../../../../../components/auth/saude/profissionais/listar'


function ListarProfissionaisSaudeScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Profissionais da Secretaria Municipal de Saúde" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarProfissionaisSaudeScreen;